import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

const SystemDetails = (props: { systemFormPayload: UseFormPayload }) => {
  const { systemFormPayload } = props

  const {
    entityState: {
      email,
      short_name,
      title,
      url,
    },
    errors,
    handlers,
  } = systemFormPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column', padding: 'large' }} title="Details">
      <Form.Row>
        <Form.Field label="* Title" errorMessage={errors.title}>
          <input name="title" value={title} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="* Email" errorMessage={errors.email} marginTop={['large', 0]}>
          <input name="email" type="email" value={email} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="Short Name">
          <input name="short_name" value={short_name} {...handlers} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="* URL" errorMessage={errors.url} marginTop={['large', 0]}>
          <input name="url" value={url} {...handlers} />
        </Form.Field>
      </Form.Row>
    </DashboardModule>
  )
}

export default SystemDetails
